<template>
    <div :class="map !== undefined || map === false ? '' : 'view'">
        <div class="d-md-flex justify-content-md-between">
            <Breadcrumb :breadcrumb="breadcrumb"/>
            <div class="navigation duties" v-if="single_object.next || single_object.previous" style="width: 200px">
                <div class="d-flex justify-content-end" style="gap: 6px;">
                    <a class="navigation__item modal__buttons__item" :href="previous() ? `${child_href}/${previous()}`: '#'" :class="{'disabled button__disabled' : !previous()}" :disabled="!previous()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="11.702" height="21.184" viewBox="0 0 11.702 21.184">
                            <g id="left-arrow" transform="translate(0.313 0.312)">
                                <g id="Grupo_6167" data-name="Grupo 6167" transform="translate(0 0)">
                                <path id="Trazado_3202" data-name="Trazado 3202" d="M104.207,10.275l8.935,8.934a.791.791,0,0,1-1.119,1.119l-9.494-9.493a.791.791,0,0,1,0-1.119L112.023.223a.791.791,0,0,1,1.119,1.119Z" transform="translate(-102.298 -0.001)" stroke="#fff" stroke-width="0.5"/>
                                </g>
                            </g>
                        </svg>
                        Previous
                    </a>
                    <a class="navigation__item modal__buttons__item ml-0" :href="next() ? `${child_href}/${next()}`: '#'" :class="{'disabled button__disabled' : !next()}" :disabled="!next()">
                        Next
                        <svg xmlns="http://www.w3.org/2000/svg" width="11.702" height="21.184" viewBox="0 0 11.702 21.184">
                            <g id="left-arrow" transform="translate(0.313 0.312)">
                                <g id="Grupo_6167" data-name="Grupo 6167" transform="translate(0 0)">
                                <path id="Trazado_3202" data-name="Trazado 3202" d="M104.207,10.275l8.935,8.934a.791.791,0,0,1-1.119,1.119l-9.494-9.493a.791.791,0,0,1,0-1.119L112.023.223a.791.791,0,0,1,1.119,1.119Z" transform="translate(-102.298 -0.001)" stroke="#fff" stroke-width="0.5"/>
                                </g>
                            </g>
                        </svg>
                    </a>
                </div>
                <div class="formdynamic__item__field mt-3">
                    <select class="input-field custom-select" style="min-width: 100px;" v-model="jump_to">
                        <option value='' v-html="'Jump to'"/>
                        <option v-for="(item, i) in daily_assignments_collection" :key="i" :value="item.id" v-html="`${item.number_assigment} - ${item.description}`"/>
                    </select>
                </div>
            </div>
        </div>
        <h1 class="view__title title--1">
            <span v-html="title_page"/>
            <span v-if="historiable" style="margin-left:5px;">
                <img src="/assets/img/svg/history.svg" class="iconHistory" alt="History" @click="history(single_object.id, single_object.name || single_object.description)" style="margin-top:-5px;">
            </span>
        </h1>
        <span class="view__description__text" v-html="comment_under_title"/>

        <h6 class="view__title title--1" style="font-size: 13px; font-weight: initial; color: gray; margin-top: -10px;" v-if="default_description !== undefined && !default_description">
            <span>
                <img src="/assets/img/svg/information.svg" style="width:15px;" alt="CustomDescription">
            </span>
        </h6>

        <div class="col-md-12 p-0">
            <span class="button__modal text-right">
                <a href="#" @click="form_modal()" class="d-inline-md-block">
                        Assignment Note
                    <i class="prefix ml-1">
                        <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                    </i>
                </a>
            </span>
        </div>

        <div class="detail__content">
            <div class="row mb-0">
                <div class="col-12 col-md-12 py-0">
                    <form class="detail__content__formdynamic" @submit.prevent="live_edition()">
                        <FormDynamic
                            :form_format="form_format"
                            :form_data="single_object"
                            :array_options="array_options"
                            :for_update="true"
                            content_align_x="justify-content-md-start"
                            class="pt-0"
                        />  
                        <slot :name="`under-form-component`"></slot> 
                        <div v-show="unalterable === undefined || unalterable === true" class="text-center text-md-right modal__buttons">
                            <a :href="back_href" class="modal__buttons__item cancel" v-html="'Back'" style="margin-right:10px;">
                                <svg xmlns="http://www.w3.org/2000/svg" width="10.121" height="6.121" viewBox="0 0 10.121 6.121">
                                    <g id="down" transform="translate(1.061 1.061)">
                                        <line id="Línea_794" data-name="Línea 794" class="cls-1" x1="4" y1="4"/>
                                        <line id="Línea_795" data-name="Línea 795" class="cls-1" y1="4" x2="4" transform="translate(4)"/>
                                    </g>
                                </svg>
                            </a>
                            <button ref="submitButton" class="btn-small-for-views mx-md-0 modal__buttons__item" v-html="'Save changes'"/>
                        </div>   
                    </form>
                </div>
            </div>
        </div>

        <!-- <div v-if="unalterable === undefined || unalterable === true" class="text-center text-md-right modal__buttons">
            <a :href="back_href" class="modal__buttons__item cancel" v-html="'Back'">
                <svg xmlns="http://www.w3.org/2000/svg" width="10.121" height="6.121" viewBox="0 0 10.121 6.121">
                    <g id="down" transform="translate(1.061 1.061)">
                        <line id="Línea_794" data-name="Línea 794" class="cls-1" x1="4" y1="4"/>
                        <line id="Línea_795" data-name="Línea 795" class="cls-1" y1="4" x2="4" transform="translate(4)"/>
                    </g>
                </svg>
            </a>
            <a class="mx-md-0 modal__buttons__item" @click="live_edition()" v-html="'Save changes'"/>
        </div> -->


        <UpdateModal
            :title="'Note Update'"
            :breadcrumb="breadcrumb"
            :parent_id="parent_id"
            :rest_api="rest_api_note"
            :array_options="array_options"
            :global_index="global_index"
            :single_object="single_note"
            @spliceObject="splice_object($event)"
        />

        <DeletionModal 
            :single_object="single_note" 
            :global_index="global_index" 
            @objectDeletion="deletion_filter($event)"
        />

        <WaitingModal/>

        <HistoryMovementModal
            :ref="'HistorialMovement'"
            :notyf="notyf"
            :link_message="`<a href='#'>Back to History</a>`"
            :rest_api="`daily_assignments`"
            :history_item="history_item"
            :breadcrumb="breadcrumb"
            :link_event="true"
            :refresh="true"
            @linkEventReceiver="linkEmitEmisor()"
        />

        <HistoryModal
            v-if="historiable"
            :link_message="`<a href='#'>View room movement history</a>`"
            :histories="histories"
            :title="history_title"
            :breadcrumb="breadcrumb"
            :link_event="true"
            @linkEventReceiver="linkEmitReceptor()"
        />

    </div>
</template>

<script>

import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import HistoryMovementModal from '@/components/AssigmentsComponent/DailyAssignment/HistoryMovementModal'
import WaitingModal from '@/components/WaitingModal'
import FormDynamic from '@/components/FormDynamic'
import DeletionModal from '@/components/DeletionModal'
import UpdateModal from './UpdateModal'
import HistoryModal from '@/components/HistoryModal'
import { Notyf } from 'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
import 'vuetify/dist/vuetify.min.css'
const notyf = new Notyf({
    duration: 8000,
});

export default {
    name:   'DetailComponentDailyAssignment',

    props: [
        'breadcrumb',
        'title_page',
        'parent_id',
        'rest_api',
        'rest_api_lite',
        'child_href',
        'rest_api_note',
        'single_object',
        'array_options',
        'form_format',
        'notes',
        'back_href',
        'map',
        'default_description',
        'comment_under_title',
        'unalterable',
        'historiable',
        'daily_assignments_collection'
    ],

    components: {
        Breadcrumb,
        WaitingModal,
        FormDynamic,
        DeletionModal,
        UpdateModal,
        HistoryModal,
        HistoryMovementModal,
    },
    
    data() {
        return {
            notyf,
            add_btn: 'Add note',
            global_index: null,
            single_note: {},
            histories: [],
            history_title: '',
            history_item: {},
            jump_to: '',
            first_time: true
        }
    },
    
    watch:{
        async jump_to(val)
        {
            if(val && !this.first_time)
            {
                window.location.href = `${this.child_href}/${val}`
            }
            else
            {
                this.first_time = false
            }
        }
    },

    methods: {
        setJumpToValue(id)
        {
            this.jump_to = id
        },

        linkEmitReceptor()
        {
            window.$('#static-history').modal('hide')

            setTimeout(() => {
                window.$('#static-history-movement').modal('show')
            }, 500)
        },

        linkEmitEmisor()
        {
            window.$('#static-history-movement').modal('hide')

            setTimeout(() => {
                window.$('#static-history').modal('show')
            }, 500)
        },

        form_modal()
        {
            this.$emit('AssignmentNote', true)
            // window.$('#static').modal('show')
        },

        modal_update(index)
        {
            this.global_index = index
            this.single_note  = this.notes[index]
            window.$('#static-update').modal('show')
        },

        unshift_object(new_object)
        {
            this.notes.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.notes.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        modal_deletion(index)
        {
            this.global_index = index
            this.single_note  = this.notes[index]
            window.$('#static-deletion').modal('show')
        },

        deletion_filter(object)
        {
            let object_destroyed = {
                id:        object.id,
                index:     object.index,
                parent_id: this.parent_id,
            }
            this.json_destroyed(this.rest_api_note, object_destroyed)
        },

        trashing(index)
        {
            this.global_index = ''
            this.single_note  = {}
            this.notes.splice(index, 1)
        },

        async live_edition(outside = false)
        {
            if(outside)
            {
                this.$refs.submitButton.click()
                return true
            }

            let response = await this.queryGetByMethod(this.rest_api, this.single_object)

            if(response.status)
            {
                this.$emit('elementsGetter', response.data)
                this.$emit('saveOutside', true)
                notyf.success('Success')
                return true
            }
            else
            {
                this.error_handling(response)
                return false
            }
        },

        async history(id, title)
        {
            this.history_item = null

            if(title === undefined)
            {
                title = id.title
                id = id.id
            }
            const http_request = {
                id,
                history_request: true,
            }

            this.history_item = {
                id,
                title,
            }

            await this.$refs.HistorialMovement.historialRefresh()

            this.loader(true)
            const response = await this.get(`${this.rest_api_lite}/${JSON.stringify(http_request)}`)
            this.loader()
            if(response.status)
            {
                this.history_title = title
                this.histories = response.data.histories
                if(this.histories.length === 0)
                {
                    return this.notyf.error('Empty History')
                }
                setTimeout(()=>{
                    window.$('#static-history').modal('show')
                }, 500)
            }
            else
            {
                this.error_handling(response)
            }  
        },

        get_rooms()
        {
            return JSON.parse(localStorage.getItem('rooms'))
        },

        next()
        {
            const daily_assignments_collection = this.daily_assignments_collection
            if(daily_assignments_collection.length)
            {
                const index = daily_assignments_collection.findIndex(item => item.number_assigment === this.single_object.number_assigment)
                return index + 1 < daily_assignments_collection.length ? daily_assignments_collection[index + 1].id : null
            }
            
            return null
        },

        previous()
        {
            const daily_assignments_collection = this.daily_assignments_collection
            if(daily_assignments_collection.length)
            {
                const index = daily_assignments_collection.findIndex(item => item.number_assigment === this.single_object.number_assigment)
                return index > 0 ? daily_assignments_collection[index - 1].id : null
            }
            return null
        },

    },
}
</script>